import * as h2Api from '../h2Api'

export const UPDATE_PAGE_TITLE = 'UPDATE_PAGE_TITLE'
export const MANAGER_MENU_TOGGLE = 'MANAGER_MENU_TOGGLE'

export const updatePageTitle = pageTitle => dispatch => {
  console.log('UPDATE TO', pageTitle)
  document.title = pageTitle ? pageTitle : dynamicValues.systemName

  return dispatch({ type: UPDATE_PAGE_TITLE, pageTitle })
}

export const toggleManagerMenu = () => dispatch => {
  return dispatch(h2Api.post('/user/toggleCollapsed', {})({ type: MANAGER_MENU_TOGGLE }))
}
